// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'

export function getDistricts(appState: ApplicationState): District[]{
  return _getDistricts(appState.map) 
}

function _getDistricts(state: MapState): District[]{
  return state.districts
}

getDistricts.internal = _getDistricts
